module.exports = __webpack_public_path__ + "img/机组.712fee1c.svg";